module.exports = __webpack_public_path__ + "static/project2-72d0d71900dee6c1c3b754157a9708a0.jpg";